import * as UUID from "uuidjs";

const windowUuid = () => {
  const w: any = window;
  w.snoamUuid = w.snoamUiud || UUID.generate();
  return w.snoamUuid;
};

export default windowUuid;
